// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';

import arrearCollectionActionTypes from './arrear-Collection.types';
import {
	fetchArrearLoanList,
	arrearCollectionApproveAPI,
	updateCommonLoanPaidDetailsAPI,
} from './arrear-Collection.service';

import {
	fetchArrearMemberLoanInfoSuccess,
	fetchArrearMemberLoanInfoFailure,
	fetchArrearMemberLoanInfoResponseChanged,
	updateArrearCollectionApproveResponseChanged,
	updateArrearCollectionApproveSuccess,
	updateArrearCollectionApproveFailure,
	updateCommonLoanPaidDetailsSuccess,
	updateCommonLoanPaidDetailsFailure,
	updateCommonLoanPaidDetailsResponseChanged,
} from './arrear-Collection.action';

import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START MEMBER LOAN LIST DETAILS  ******************** */
export function* getArrearMemberLoanList({ payload }: any) {
	try {
		const {
			officerID,
			databaseName,
			arrearCollectionDate,
			companyID,
			branchID,
			centerID,
			groupID,
			userLevel,
			userID,
		} = payload;
		const key = 'FetchArrearMemberListKey';
		const jsonData = {
			GroupOfficerID: officerID,
			DatabaseName: databaseName,
			RepayDate: arrearCollectionDate,
			FromDate: arrearCollectionDate,
			ToDate: arrearCollectionDate,
			CompanyID: companyID,
			BranchID: branchID,
			LocationID: centerID,
			GroupID: groupID,
			UserLevel: userLevel,
			UserID: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchArrearLoanList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchArrearMemberLoanInfoFailure(responseData.data));
		} else {
			yield put(fetchArrearMemberLoanInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchArrearMemberLoanInfoFailure(error));
	}
}

export function* resetGetArrearMemberLoanListResponse() {
	yield put(fetchArrearMemberLoanInfoResponseChanged());
}

export function* onGetArrearMemberLoanListDetails() {
	yield takeLatest(
		arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_START,
		getArrearMemberLoanList,
	);
}

export function* onGetArrearMemberLoanListResponseReset() {
	yield takeLatest(
		arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_RESPONSE_RESET,
		resetGetArrearMemberLoanListResponse,
	);
}
/** *********************  END GET MEMBER LOAN LIST  ******************** */

/** *********************  START ARREAR COLLECTION APPROVE UPDATE  ******************** */
export function* approveArrearCollectionList({ payload }: any) {
	try {
		const key = 'UpdateApproveArrearMemberKey';
		const {
			databaseName,
			companyID,
			loanPaidIDs,
			loanIndexGroupMemberID,
			memberID,
			userID,
			userName,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanPaidIDs: loanPaidIDs,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			UserID: userID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(arrearCollectionApproveAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateArrearCollectionApproveFailure(responseData.data));
		} else {
			yield put(updateArrearCollectionApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateArrearCollectionApproveFailure(error));
	}
}

export function* resetArrearCollectionApproveResponse() {
	yield put(updateArrearCollectionApproveResponseChanged());
}

export function* onArrearCollectionApprove() {
	yield takeLatest(
		arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_START,
		approveArrearCollectionList,
	);
}

export function* onArrearCollectionApproveResponseReset() {
	yield takeLatest(
		arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_RESPONSE_RESET,
		resetArrearCollectionApproveResponse,
	);
}
/** *********************  END ARREAR COLLECTION APPROVE UPDATE  ******************** */

/** *********************  START UPDATE COMMON LOAN PAID DETAILS  ******************** */
export function* updateCommonLoanPaidDetailsSaga({ payload }: any) {
	try {
		const key = 'UpdateCommonLoanPaidDetailsKey';
		const {
			userID,
			userName,
			companyID,
			databaseName,
			branchID,
			centerID,
			groupID,
			officerID,
			arrearCollectionDate,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenomination,
			totalamount,
			receiptNumber,
			chequeNumber,
			collectionLoanArr,
			thriftArr,
			paymentMethod,
			paymentFrom,
			payFromWalet,
			walletAmount,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			CollectionLoanArr: collectionLoanArr,
			ThriftArr: thriftArr,
			DatabaseName: databaseName,
			UserID: userID,
			UserName: userName,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			OfficerID: officerID,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			TotalDenomination: totalDenomination,
			TotalAmount: totalamount,
			// IsAllCenter: isAllCenter,
			// 	IsGroup: isGroup,
			paymentMethod,
			collectionPage: paymentFrom,
			arrearCollectionDate,
			receiptNumber,
			chequeNumber,
			payFromWalet,
			walletAmount,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateCommonLoanPaidDetailsAPI, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCommonLoanPaidDetailsFailure(responseData.data));
		} else {
			yield put(updateCommonLoanPaidDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCommonLoanPaidDetailsFailure(error));
	}
}

export function* resetUpdateCommonLoanPaidDetailsResponse() {
	yield put(updateCommonLoanPaidDetailsResponseChanged());
}

export function* onUpdateCommonLoanPaidDetails() {
	yield takeLatest(
		arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_START,
		updateCommonLoanPaidDetailsSaga,
	);
}

export function* onUpdateCommonLoanPaidDetailsResponseReset() {
	yield takeLatest(
		arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_RESPONSE_RESET,
		resetUpdateCommonLoanPaidDetailsResponse,
	);
}
/** *********************  END UPDATE COMMON LOAN PAID DETAILS  ******************** */

export function* arrearCollectionSaga() {
	yield all([
		call(onGetArrearMemberLoanListDetails),
		call(onGetArrearMemberLoanListResponseReset),
		call(onArrearCollectionApprove),
		call(onArrearCollectionApproveResponseReset),
		call(onUpdateCommonLoanPaidDetails),
		call(onUpdateCommonLoanPaidDetailsResponseReset),
	]);
}
